import { styled } from 'styled-components';

export const SectionVideo = styled.section`
  background-color: ${({ theme }) => theme.colors.blue300};

  .video__container {
    display: flex;
    flex-direction: column;
    gap: clamp(48px, 3.068vw + 38.176px, 75.008px);
    align-items: center;
    padding-top: clamp(3.75rem, 2.273vw + 3.295rem, 5rem);
    padding-bottom: clamp(3.75rem, 2.273vw + 3.295rem, 5rem);

    @media (max-width: ${({ theme }) => theme.breakpoint.tablet}) {
      padding: 30px 0 40px 0;
    }

    @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
      padding: 20px 0 10px 0;
      gap: 30px;
    }
  }
`;

export const VideoDescription = styled.span`
  font-weight: 400;
  font-size: 22px;
  line-height: 114%;
  text-align: center;
  max-width: 668px;
  color: ${({ theme }) => theme.colors.gray600};

  @media (max-width: ${({ theme }) => theme.breakpoint?.tablet}) {
    font-size: 18px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    font-size: 16px;
    margin: 0 16px;
  }
`;

export const VideoContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    width: 100vw;
    max-width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
  }
`;

export const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

  /* Scroll performance optimizations */
  contain: strict;
  isolation: isolate;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 12px;
    pointer-events: auto;
    transition: opacity 0.2s ease;
  }

  /* Disable iframe interactions during potential scroll conflicts */
  &:hover iframe {
    pointer-events: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}) {
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

    iframe {
      border-radius: 8px;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    border-radius: 6px;

    iframe {
      border-radius: 6px;
      /* More aggressive scroll optimization on mobile */
      pointer-events: none;
    }

    &:hover iframe,
    &:focus-within iframe {
      pointer-events: auto;
    }
  }
`;
